import axios from './configObra/config-obra'
const defaultRoute = 'configs/'
export default{
    list:(filter, filial)=>{
        return axios.get(`${defaultRoute}?${filter}=${filial}`)
    },
    create:(user)=>{
        return axios.post(defaultRoute,user)
    },
    update:(id, user)=>{
        return axios.patch(`${defaultRoute}${id}`, user)
    },
    remove:(id)=>{
        return axios.delete(defaultRoute+id)
    }
} 